import { render, staticRenderFns } from "./SnackBar.vue?vue&type=template&id=477b394b&"
import script from "./SnackBar.vue?vue&type=script&lang=js&"
export * from "./SnackBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports